<!-- 收款台操作 -->
<template>
    <div class="store-modal-content">
        <div class="data_action_form">
            <el-card class="box-card" body-style="padding:0;border:1px solid #E4E7ED" v-if="formDataList">
                <v-tabs :type="dataActionBox.actionType" :activeName="showTabs" :name="'jciName'" :value="'jciName'" :tabslist="formDataList" @tabs="(val) => {showTabs = val}">
                    <template slot="tabs" slot-scope="scope">
                        <div class="table_content_box">
                            <!-- 主信息 -->
                            <div v-if="scope.index == 0">
                                <el-form size="mini" inline :model="sendDataInfo" label-width="150px" ref="sendDataInfo" :show-message="false">
                                    <el-form-item label="收款台编码" prop="deskCode"
                                                  :rules="[{ required: true, message: '请输入收款台编码', trigger: 'blur' },{ pattern: /^[0-9]{1,2}$/, message: '收款台编码只能输入1-2位数字', trigger: 'blur' }]">
                                        <label slot="label" :style="$common.labelStyle('收款台编码')" v-html="$common.htmlLabel('收款台编码')"></label>
                                        <el-input class="form_codition" v-model.trim="sendDataInfo.deskCode" maxlength="2" type="number" :max="99" placeholder="填写收款台编码" @input="validateDeskCode"></el-input>
                                    </el-form-item>
                                    <el-form-item label="收款台状态" prop="deskState">
                                        <label slot="label" :style="$common.labelStyle('收款台状态')" v-html="$common.htmlLabel('收款台状态')"></label>
                                        <el-select v-model="sendDataInfo.deskState" placeholder="请选择" class="form_codition">
                                            <el-option label="禁用" :value="0"></el-option>
                                            <el-option label="启用" :value="1"></el-option>
                                        </el-select>
                                    </el-form-item>
                                    <el-form-item label="收款台类型" prop="deskType">
                                        <label slot="label" :style="$common.labelStyle('收款台类型')" v-html="$common.htmlLabel('收款台类型')"></label>
                                        <el-select v-model="sendDataInfo.deskType" placeholder="请选择" class="form_codition">
                                            <el-option label="收款" :value="'收款'"></el-option>
                                            <el-option label="划价" :value="'划价'"></el-option>
                                        </el-select>
                                    </el-form-item>
                                    <el-form-item label="门店名称" prop="storeId" :rules="[{ required: true, trigger: ['blur', 'change'] }]">
                                        <label slot="label" :style="$common.labelStyle('门店名称')" v-html="$common.htmlLabel('门店名称')"></label>
                                        <el-input clearable v-model="sendDataInfo.storeName" class="form_codition" @keyup.enter.native="openSearch('293839281728',0,'storeName','storeId,storeName')">
                                            <el-button @click="openSearch('293839281728',0,'storeName','storeId,storeName')" slot="append" icon="el-icon-search"></el-button></el-input>
                                    </el-form-item>
                                    <el-form-item label="默认销售员" prop="salesPersonId">
                                        <label slot="label" :style="$common.labelStyle('默认销售员')" v-html="$common.htmlLabel('默认销售员')"></label>
                                        <el-input clearable v-model="sendDataInfo.salesPersonName" class="form_codition" @keyup.enter.native="openSearch(293839280003,0,'salesPersonName','salesPersonId,salesPersonName')">
                                            <el-button @click="openSearch(293839280003,0,'salesPersonName','salesPersonId,salesPersonName')" slot="append" icon="el-icon-search"></el-button></el-input>
                                    </el-form-item>
                                    <el-form-item label="是否允许抹零" prop="isSmall">
                                        <label slot="label" :style="$common.labelStyle('是否允许抹零')" v-html="$common.htmlLabel('是否允许抹零')"></label>
                                        <el-select v-model="sendDataInfo.isSmall" placeholder="请选择" class="form_codition">
                                            <el-option label="不抹零" :value="0"></el-option>
                                            <el-option label="四舍五入" :value="1"></el-option>
                                            <el-option label="舍去" :value="2"></el-option>
                                        </el-select>
                                    </el-form-item>
                                </el-form>
                            </div>
                        </div>
                    </template>
                </v-tabs>
            </el-card>
        </div>
        <div class="dialog-footer">
            <el-button @click="drawerCancel">取 消</el-button>
            <el-button type="primary" @click="sendDataAction()">保 存</el-button>
        </div>
        <!-- 检索方案 -->
        <el-dialog :title="seTitle" v-if="DialogVisible" :visible.sync="DialogVisible" :width="seWidth" :modal-append-to-body="true" :append-to-body="true" @close="closeChild">
            <SearchScheme ref="searchScheme" :id="seId" :parentSearchData="parentSearchData" @TranData="changeInputModel" @getWidth="getSeWidth" @sendTitle="getSearchName" />
        </el-dialog>
    </div>
</template>

<script>
export default {
    props: ["actionData"],
    name: "cashDeskModal",
    data() {
        return {
            dataActionBox: {
                actionType: 0, // 0新增，1修改
            },
            sendDataInfo: {
                storeName: "",
                deskCode: null,
                deskState: 1,
                deskType: "收款",
                isSmall: 0,
                ormId: 0,
                storeId: 0,
                deskId: 0,
                salesPersonId: '',
                salesPersonName: "",
            },
            formDataList: [],

            showTabs: "",
            DialogVisible: false, //判断是否打开检索方案弹框
            seTitle: "", //检索方案的名称
            seType: "", //检索方案查询条件字段
            seWidth: "", //检索方案弹框的宽度
            seTitle: "", //检索方案的名称
            sField: "", //赋值字段
            parentSearchData: {}, //检索方案补充的查询列表的查询条件
        }
    },
    methods: {
        async openBox() {
            if (this.actionData.cate == 0) {
                this.showTabs = "新增收款台信息"
                this.formDataList = [
                    {
                        jciName: "新增收款台信息",
                        jurconfigform: [],
                    },
                ]
            } else {
                // 回显数据
                console.log(this.actionData.oldData, 'this.actionData.oldData');

                if (this.actionData.oldData) {
                    for (let key in this.actionData.oldData) {
                        this.$set(this.sendDataInfo, key, this.actionData.oldData[key])
                    }
                }
                this.parentSearchData.storeId = this.sendDataInfo.storeId
                this.sendDataInfo.salesPersonName = this.actionData.oldData.salerName
                this.sendDataInfo.salesPersonId = this.actionData.oldData.defaultSaler
                this.formDataList = [
                    {
                        jciName: "编辑收款台信息",
                        jurconfigform: [],
                    },
                ]
                this.showTabs = "编辑收款台信息"
            }

            this.dataActionBox.actionType = this.actionData.cate
        },
        //检索方案获取的数据清除
        clear(val) {
            if (val) {
                var arr = val.split(",")
                arr.forEach((item) => {
                    this.$set(this.getRequestData, item, "")
                })
            }
        },
        //获取检索方案弹框宽度
        getSeWidth(e) {
            this.seWidth = e + "%"
        },
        //获取检索方案弹框名称
        getSearchName(e) {
            this.seTitle = e
        },
        // 检索Id, 索引(表格中), 标识
        openSearch(sId, index, type, sField) {
            this.seId = sId //检索方案Id
            this.sField = sField //赋值字段
            this.DialogVisible = true //判断是否打开弹框
            this.seType = type
            if (type == 'pschaName') {
                this.parentSearchData.storeId = this.sendDataInfo.storeId
            }
        },
        //检索方案返回的数据
        changeInputModel(val) {
            if (val != "" || val != undefined) {
                this.DialogVisible = false
                this.paramValue(val) //赋值字段，赋值
            }
        },
        // 赋值字段
        paramValue(val) {
            if (this.seType == 'storeName') {
                this.parentSearchData.storeId = val.storeId
            }
            let arr = this.sField.split(",")
            arr.forEach((item) => {
                this.sendDataInfo[item] = val[item]
            })
        },
        //关闭提取、检索方案弹框关闭 创建键盘事件
        closeChild() {
            addEventListener("keyup", this.keyUp) //创建监听键盘事件
        },
        async sendDataAction() {
            // 表单验证
            this.$refs.sendDataInfo.validate(async (valid) => {
                if (valid) {
                    let sendData = JSON.parse(JSON.stringify(this.sendDataInfo))
                    sendData.deskCode = Number(sendData.deskCode)
                    sendData.defaultSaler = Number(sendData.salesPersonId)
                    try {
                        let responseData
                        // 如果是新增
                        if (this.dataActionBox.actionType == 0) {
                            responseData = await this.$http.addcashdesk(sendData)
                        }
                        // 如果是编辑
                        else if (this.dataActionBox.actionType == 1) {
                            responseData = await this.$http.updcashdesk(sendData)
                        }

                        if (responseData.status == 200) {
                            this.$message({
                                message:
                                    this.dataActionBox.actionType == 0 ? "新增成功" : "编辑成功",
                                type: "success",
                            })
                            this.$emit("drawerCancel", false)
                            this.$emit("toDetail", responseData.result)
                        } else {
                            this.$message({
                                message: responseData.message,
                                type: "error",
                            })
                        }
                    } catch (error) {
                        console.error("error", error)
                        this.$message({
                            message: "操作失败",
                            type: "error",
                        })
                    }
                } else {
                    this.$message({
                        message: "请填写必填项",
                        type: "error",
                    })
                    return false
                }
            })
        },

        drawerCancel() {
            this.$confirm("确认关闭弹窗吗？未保存的数据将丢失。", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    this.$emit("drawerCancel", false)
                })
                .catch(() => { })
        },

        // 校验收款台编码
        validateDeskCode(value) {
            // 移除非数字字符
            let cleanValue = value.replace(/[^0-9]/g, '');

            // 限制为两位数
            if (cleanValue.length > 2) {
                cleanValue = cleanValue.substring(0, 2);
            }

            // 更新输入值
            this.sendDataInfo.deskCode = cleanValue;
        },
    },
    created() {
        this.openBox()
    },
}
</script>
<style scoped>
.store-modal-content {
    padding: 20px;
    max-height: 70vh;
    overflow-y: auto;
}

.data_action_form {
    width: 100%;
}

.dialog-footer {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    background: #fff;
    height: 46px;
    padding: 5px 10px;
    margin-top: 20px;
    border-top: 1px solid #eee;
}
</style>
